import { useEffect, useRef } from 'react';

export default function useCanvasPan(canvasInstance, onMove) {
    const isDragging = useRef(false);
    const lastPosX = useRef(0);
    const lastPosY = useRef(0);

    useEffect(() => {
        const canvas = canvasInstance.current;
        if (!canvas) return;

        const handleMouseDown = (opt) => {
            isDragging.current = true;
            lastPosX.current = opt.e.clientX;
            lastPosY.current = opt.e.clientY;
            canvas.setCursor('grab');
        };

        const handleMouseMove = (opt) => {
            if (!isDragging.current) return;
            canvas.setCursor('grabbing');
            const e = opt.e;
            const dx = e.clientX - lastPosX.current;
            const dy = e.clientY - lastPosY.current;

            lastPosX.current = e.clientX;
            lastPosY.current = e.clientY;

            const vpt = canvas.viewportTransform;
            vpt[4] += dx;
            vpt[5] += dy;

            
            canvas.requestRenderAll();

            if (onMove) {
                onMove({ left: dx, top: dy });
            }
        };

        const handleMouseUp = () => {
            isDragging.current = false;
            canvas.setCursor('grab');
        };

        canvas.on('mouse:down', handleMouseDown);
        canvas.on('mouse:move', handleMouseMove);
        canvas.on('mouse:up', handleMouseUp);
        canvas.on('mouse:out', handleMouseUp);
        canvas.on('mouse:over', () => {canvas.setCursor('grab')});

        return () => {
            canvas.off('mouse:down', handleMouseDown);
            canvas.off('mouse:move', handleMouseMove);
            canvas.off('mouse:up', handleMouseUp);
        };
    }, [canvasInstance, onMove]);
}
